import { Link, Typography } from '@mui/material';
import { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import {
  markMigrationNotificationShown,
  shouldShowMigrationNotification,
  useToast,
} from '#features';
import { routes } from '#shared';

import type { FC } from 'react';

/**
 * Component that checks if migration notification should be shown
 * and displays it once when user transitions from persist v1 to v2.
 *
 * Shows a dismissible notification with a link to Settings page.
 */
export const MigrationNotification: FC = () => {
  const { showToast, ToastComponent } = useToast();

  useEffect(() => {
    // Check on mount if notification should be shown
    if (shouldShowMigrationNotification()) {
      // Mark as shown immediately to prevent multiple triggers
      markMigrationNotificationShown();

      // Show notification with custom message including link
      showToast(
        <Typography component="div" variant="body2">
          <strong>Settings reset</strong>
          <br />
          Your previous screen layout was reset as part of the latest update.
          <br />
          You can customize it in{' '}
          <Link
            component={RouterLink}
            to={routes.SETTINGS}
            sx={{
              color: 'inherit',
              textDecoration: 'underline',
              fontWeight: 'bold',
              '&:hover': {
                textDecoration: 'none',
              },
            }}
          >
            Settings
          </Link>
          .
        </Typography>,
        'info',
        { vertical: 'top', horizontal: 'center' },
        30000, // 30 seconds auto-hide duration
      );
    }
  }, [showToast]);

  return <ToastComponent />;
};
